import { hasPackage } from '@/utils/package';

// 智推标准版        10035
// 智推社交零售版        10028
// 智推专业版        10019
// 智推基础版        10063
// 智推企业版        10064
// 会员营销-线性账号        10065
function hasZhituiPackage() {
    return (
        hasPackage('10019') ||
        hasPackage('10028') ||
        hasPackage('10035') ||
        hasPackage('10063') ||
        hasPackage('10064') ||
        hasPackage('10065')
    );
}

export default hasZhituiPackage();
